import styled from "@emotion/styled";
import { CloseButton } from "src/atoms/CloseButton";

const StyledBrandInfo = styled.section<{
  isMobile: boolean;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 320px;
  max-width: 600px;
  max-height: ${({ isMobile }) => (isMobile ? "100%" : "800px")};
  background: ${({ theme }) => theme.colors.tone.white};
`;

const StyledInfoHeader = styled.header`
  padding: ${({ theme }) => theme.space.space16};
  width: 100%;
  position: relative;
  justify-content: center;
  align-items: center;
  font-size: ${({ theme }) => theme.fontSizes[0]}px;
  color: ${({ theme }) => theme.colors.tone.anthraciteDark};
  letter-spacing: 0.2em;
  border-bottom: 1px solid ${({ theme }) => theme.colors.primary.platinumLight};
`;

const StyledCloseButton = styled(CloseButton)`
  position: absolute;
  right: 0;
  padding: 20px;
  height: 56px;
  width: 56px;
  top: 50%;
  transform: translate(0, -50%);
`;

// TODO: Will refactor this after we get the data from Contentful
const StyledBrandInfoContent = styled.div`
  padding: ${({ theme }) => theme.space[3]}px;
  color: ${({ theme }) => theme.colors.tone.anthracite};
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  letter-spacing: 0.21px;
  line-height: 24px;

  p + p {
    display: flex;
    flex-direction: column;
    margin-top: ${({ theme }) => theme.space[3]}px;
  }

  strong {
    font-family: "PlusJakartaSans";
    font-size: 18px;
    margin-top: ${({ theme }) => theme.space[2]}px;
    color: ${({ theme }) => theme.colors.tone.black};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    padding: ${({ theme }) => theme.space[5]}px;
  }
`;

const StyledConsciousContent = styled.div`
  margin-top: ${({ theme }) => theme.space[3]}px;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    margin-top: ${({ theme }) => theme.space[5]}px;
  }
`;

export {
  StyledBrandInfo,
  StyledConsciousContent,
  StyledBrandInfoContent,
  StyledInfoHeader,
  StyledCloseButton,
};
